module.exports = __webpack_public_path__ + "media/images/city_img/t_5-0e607ba3809a8aac2b26e5f4abe867ca.png";